import { Controller } from "@hotwired/stimulus"
import linkifyHtml from "linkify-html"

export default class extends Controller {
  connect() {
    // eslint-disable-next-line no-unsanitized/property -- linkify rewrites the element's own markup, adding only anchors
    this.element.innerHTML = linkifyHtml(this.element.innerHTML, {
      attributes: {
        title: "External link",
      },
      ignoreTags: ["script", "style"],
      rel: "nofollow",
      target: {
        url: "_blank",
      },
    })
  }
}
